import React from "react";
import Field from "./Field";
import { controlClasses } from "./control";

// Native select. Used both labelled (Product section) and bare, inline in an
// upload row.
export default function SelectField({
  label,
  value,
  options,
  onChange,
  size = "sm",
  required,
  className,
  wrapperClassName,
}) {
  const control = (
    <select
      value={value}
      onChange={function (event) {
        onChange(event.target.value);
      }}
      className={controlClasses(size, className)}
    >
      {options.map(function (option) {
        return (
          <option key={option} value={option}>
            {option}
          </option>
        );
      })}
    </select>
  );

  if (!label) return control;

  return (
    <Field label={label} required={required} className={wrapperClassName}>
      {control}
    </Field>
  );
}
